import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ThemeProvider } from "@/context/ThemeContext";
import { LanguageProvider } from "@/context/LanguageContext";
import { CartProvider } from "@/context/CartContext";
import { CartDrawer } from "@/components/site/CartDrawer";
import Home from "@/pages/Home";
import NotableMcDonalds from "@/pages/NotableMcDonalds";
import Recipes from "@/pages/Recipes";
import Events from "@/pages/Events";
import Shop from "@/pages/Shop";
import { PaymentSuccess, PaymentCancel } from "@/pages/PaymentReturn";
import Admin from "@/pages/Admin";

function App() {
  return (
    <ThemeProvider>
      <LanguageProvider>
        <CartProvider>
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/notable" element={<NotableMcDonalds />} />
              <Route path="/recipes" element={<Recipes />} />
              <Route path="/events" element={<Events />} />
              <Route path="/shop" element={<Shop />} />
              <Route path="/payment/success" element={<PaymentSuccess />} />
              <Route path="/payment/cancel" element={<PaymentCancel />} />
              <Route path="/admin" element={<Admin />} />
            </Routes>
            <CartDrawer />
          </BrowserRouter>
        </CartProvider>
      </LanguageProvider>
    </ThemeProvider>
  );
}

export default App;
